module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Bold.c94c29feb80b02db176028d16fc634d2.ttf";